exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".same-row-spaced-apart-aligned[data-v-0d8b6a68]{display:flex;justify-content:space-between;align-items:center}.dropdown[data-v-0d8b6a68]{width:100%}.dropdown .caret[data-v-0d8b6a68]{position:absolute;top:10px;right:10px}.dropdown .dropdown-toggle[data-v-0d8b6a68]{width:100%;text-align:left}.dropdown-menu[data-v-0d8b6a68]{width:100%;margin-top:-1px}.form-group[data-v-0d8b6a68]{word-break:break-word}input.form-control[type=file][data-v-0d8b6a68]{height:auto}label[data-v-0d8b6a68]{display:block}.el-icon-close[data-v-0d8b6a68]{opacity:.75;transform:scale(.8);cursor:pointer;margin-left:10px;color:#13ce66}.el-icon-close[data-v-0d8b6a68]:hover{color:#48576a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0d8b6a68&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App/protected/components/clients/ClientEdit.vue
// module id = 578
// module chunks = 0